import { Button, Flex, Icon } from "@chakra-ui/react";
import { FaChevronLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";

interface SigningPendingActionsProps {
  onPrevious?: () => void;
  onContinue: () => void;
  onCancel: () => void;
  isContinuing?: boolean;
  isCanceling?: boolean;
}

export const SigningPendingActions = ({
  onPrevious,
  onContinue,
  onCancel,
  isContinuing,
  isCanceling,
}: SigningPendingActionsProps) => {
  const { t } = useTranslation();
  return (
    <Flex
      direction={{ base: "column-reverse", md: "row" }}
      gap="3"
      width="full"
    >
      {onPrevious && (
        <Button
          variant="outline"
          colorScheme="teal"
          size="lg"
          onClick={onPrevious}
          leftIcon={<Icon as={FaChevronLeft} w="12px" h="12px" />}
          flex={{ md: "1" }}
          width={{ base: "full", md: "auto" }}
        >
          {t("Previous")}
        </Button>
      )}
      <Button
        variant="outline"
        colorScheme="red"
        size="lg"
        onClick={onCancel}
        isLoading={isCanceling}
        flex={{ md: "1" }}
        width={{ base: "full", md: "auto" }}
      >
        {t("Cancel signing")}
      </Button>
      <Button
        variant="solid"
        colorScheme="teal"
        size="lg"
        onClick={onContinue}
        isLoading={isContinuing}
        flex={{ md: "1" }}
        width={{ base: "full", md: "auto" }}
      >
        {t("Continue signing")}
      </Button>
    </Flex>
  );
};
